import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';



const Portal = (props: { children: React.ReactNode }): JSX.Element => {
    const el = document.createElement('div');

    useEffect(() => {
        document.body.appendChild(el);
        return () => {
            document.body.removeChild(el);
        };
    }, [el]);

    return ReactDOM.createPortal(
        props.children,
        el
    );
};

export default Portal;